import { Box, Grid, Typography, useTheme } from '@mui/material';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonBack from 'src/components/common/ButtonBack';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import MainContainer from 'src/components/common/MainContainer';
import ListPrediction from 'src/features/AIHSCodeLabeling/Common/ListPrediction';
import ListPredictionSkeleton from 'src/features/AIHSCodeLabeling/Common/ListPredictionSkeleton';
import QuickViewPanel from 'src/features/AIHSCodeLabeling/Common/QuickViewPanel';
import RelatedHsCode from 'src/features/AIHSCodeLabeling/Common/RelatedHsCode';
import FormAdjustment from 'src/features/Public/AIHSCodeLabeling/FormAdjustment';
import { AI_HS_CODE_LABELING_IMAGES } from 'src/utils/constants/imagesUrl';
import { NoAuthRouteKeys } from 'src/utils/constants/routes';
import { useSingleHSCodePredictionStore } from 'src/zustand/useAILabelingStore';

const SinglePrediction = () => {
  const [selected, setSelected] = useState<undefined | TypeSingleHSCodePrediction>(undefined);
  const navigate = useNavigate();
  const { isLoadingAIMatch, dispatch, resetStore } = useSingleHSCodePredictionStore();
  const matchGain = () => dispatch(true, 'visiblePopupMatchAgain');
  const {
    palette: { background },
    shape: { borderRadius },
    zIndex,
  } = useTheme();
  return (
    <MainContainer sx={{ marginTop: 0 }}>
      <ButtonBack
        onClick={() => {
          resetStore();
          navigate(NoAuthRouteKeys.AIHSCodeSearchPublic);
        }}
      />
      <FormAdjustment />

      <Typography mt={3} variant="h5" mb={1}>
        AI HS Code Prediction with Confidence
      </Typography>
      <Typography mb={3} color={'text.secondary'} variant="body2">
        Our AI analyzed your product and predicted the HS Code. If inaccurate, add details to refine the prediction.
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} lg={8}>
          {isLoadingAIMatch ? (
            <>
              <ListPredictionSkeleton />
            </>
          ) : (
            <>
              <ListPrediction selected={selected} onSelect={setSelected} />
            </>
          )}
        </Grid>
        <Grid item xs={12} lg={4}>
          {selected && <QuickViewPanel selected={selected} />}
          <Box mt={3} />
          {!isEmpty(selected?.related_hscodes) && <RelatedHsCode selected={selected} />}
          <Box
            mt={3}
            zIndex={zIndex.drawer}
            color={background.default}
            component={'div'}
            position={'sticky'}
            top={10}
            sx={{
              background: `url(${AI_HS_CODE_LABELING_IMAGES.single_prediction_cover})`,
              backgroundSize: 'cover',
            }}
            gap={2}
            p={2}
            borderRadius={borderRadius / 2}
          >
            <Typography color={'inherit'} variant="subtitle1">
              HS Code Mismatch
            </Typography>
            <Typography color={'text.secondary'} variant="body2">
              Enhance matching <br /> with advanced product details.
            </Typography>
            <ButtonWithLoading onClick={matchGain} sx={{ mt: 2 }} isRounded variant="outlined" color="inheritWhite">
              Match again
            </ButtonWithLoading>
          </Box>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default SinglePrediction;
